import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const servicedeskCmdbAssetsObjectRoute: InvariantJiraRoute = {
	name: 'servicedesk-cmdb-object',
	path: '/jira/servicedesk/assets/object/:objectId',
};
